import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectQuantity } from 'src/redux/basket/selectors';
import { actions as basketActions } from 'src/redux/basket/slice';
import { selectIsInStock } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type { QuantitySelectorDispatchProps, QuantitySelectorStateProps } from './QuantitySelector';

type UseQuantitySelector = QuantitySelectorDispatchProps & QuantitySelectorStateProps;

export const useQuantitySelector = (): UseQuantitySelector => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const inStock = useSelector(selectIsInStock);
  const quantity = useSelector(selectQuantity);

  const onChangeQuantity = useCallback(
    ({ quantity, valid }: { quantity: number; valid: boolean }) => {
      dispatch(basketActions.changeQuantity({ isValid: valid, quantity }));
    },
    [dispatch],
  );

  return {
    inStock,
    onChangeQuantity,
    quantity,
  };
};
